'use client';

import { inter500 } from '@/config/fonts';
import { User } from '@/containers/Users/types';
import GradientAvatar from '@/shared/components/GradientAvatar/GradientAvatar';
import UserTypeBadge from '@/shared/components/UserTypeBadge';
import classNames from 'classnames';
import { HTMLAttributes, ReactNode } from 'react';

interface UserItemViewProps extends HTMLAttributes<HTMLDivElement> {
  data: User;
  actions?: ReactNode;
  canUnassign?: boolean;
  unassignTooltip?: string;
  onUserNameClick?: () => void;
}

const UserItemView = ({
  className,
  data,
  actions,
  style,
  onUserNameClick,
}: UserItemViewProps) => {
  const displayName =
    `${data.first_name || ''} ${data.last_name || ''}`.trim() ||
    data.email ||
    'Unknown User';
  const initials = displayName
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div
      className={classNames('flex items-center justify-between', className)}
      style={style}>
      <div className="flex w-full items-center gap-3">
        <GradientAvatar gradientKey={displayName} size="md" className="shrink-0">
          {initials}
        </GradientAvatar>
        <div className="flex flex-1 flex-col gap-0.5">
          {onUserNameClick ? (
            <button
              type="button"
              className={classNames(
                'text-left hover:text-blue-600 hover:underline',
                inter500.className
              )}
              onClick={onUserNameClick}>
              {displayName}
            </button>
          ) : (
            <span className={classNames(inter500.className)}>{displayName}</span>
          )}
          <span className={classNames('text-gray-default text-[13px]')}>
            {data.email || 'No email'}
          </span>
        </div>
        <div className="mx-auto">
          <UserTypeBadge type={data.user_type} />
        </div>
        <div className="actions flex shrink-0 items-center gap-2">{actions}</div>
      </div>
    </div>
  );
};

export default UserItemView;
